import React from "react";
import SVG from 'react-inlinesvg';
import tickSvg from "../images/Tick.svg";
import {
    CheckBox, CompCheckBox,
    ContactUsOwnerOptions,
    DealerLookupField, DropDownMenu,
    InputField,
    MultipleInputFields,
    NoLabelField,
    TextArea, VideoDisplay, VideoInput,
    VINModal
} from "./FormElements";
import {connect} from "react-redux";
import {formValueSelector, change} from "redux-form";
import VideoRecorder from "react-video-recorder";
import moment from "moment";
import mimetype from "mimetype-extension";

export function YourDetailsMarketing(props){

    const {formName, icon, introCopy} = props;

    function Component(p){

        const { firstname, lastname , email , postcode , phone , brand , brandConfig } = p;
        const isCompleted = [firstname , lastname , email, postcode , phone ].every((i) => i !== undefined && i.trim().length > 0);
        return (

            <div id={'yourdetails'} className={"your-details col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <a name="yourdetails"/>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    {!isCompleted  && <SVG src={icon}/>}
                    {isCompleted && <SVG src={tickSvg}/>}<h4 className={"pt-1 pl-1"}>YOUR DETAILS</h4>
                </div>
                {introCopy && <div className={"col-12 d-flex justify-content-center section-heading"}>
                    {introCopy}
                </div>}

                <MultipleInputFields labelText={"Full name"} targetField={"firstname"} required={true}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} required={true}
                            helperText={formName.endsWith("rab") && "Please ensure your email is correct as your brochure will be sent to this address"}/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} required={true}
                helperText={"10 digits with no spaces."}/>


                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} required={true}
                            placeholder={"E.g. 2000"}/>

                {brandConfig && <div className="form-group">
                    <p className={"privacy-policy"}>
                        Stellantis (Australia and New Zealand) Pty Ltd (Stellantis Australia) respects your privacy. We will only use the information
                        you
                        provide for the purposes of processing and fulfilling your request or enquiry. We
                        may
                        disclose your information to an authorised dealer, our related companies and/or
                        third
                        parties associated with us for these purposes. If you have consented on this form,
                        we may
                        also use and disclose your information to send you marketing material about products
                        and
                        services which may be of interest to you. If you have asked to be contacted by a
                        dealer, we
                        may also disclose your information to an dealer for that purpose.
                        Our <a href={brandConfig.privacypolicy} target={"_blank"}>Privacy
                        Policy </a>
                        contains further details regarding how you can access or correct information we hold
                        about
                        you, how you can make a privacy related complaint, how that complaint will be dealt
                        with and
                        the extent to which your information may be disclosed to overseas recipients.
                    </p>
                </div>}

                {brand && formName.endsWith("rab") && <CheckBox
                    labelText={`I wish to be contacted via phone by a ${brand.name} dealer after receiving a brochure`}
                    name={"contactASAP"}/> }

                {brand && <CheckBox
                    labelText={`I wish to receive special offers, events and news from ${brand.name} Australia`}
                    name={"marketingOptIn"}/> }


            </div>

        )
    }

    const YourDetailsComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            'contactASAP' : selector(state, 'contactASAP'),
            'marketingOptIn' : selector(state, 'marketingOptIn'),
            brand : selector(state,'brand'),
            brandConfig : selector(state,'brandConfig'),
        }
    })(Component);

    return <YourDetailsComponent {...props}/>
}



export function YourDetailsNoPostcodeMarketing(props){

    const {formName, icon} = props;


    function Component(p){

        const { firstname, lastname , email , phone , brand, brandConfig} = p;
        const isCompleted = [firstname , lastname , email, phone ].every((i) => i !== undefined && i.trim().length > 0);

        return (

            <div id={'yourdetails'} className={"your-details col-12 col-lg-6 offset-lg-3 " + (isCompleted ? ` selected ` : ``) }>
                <a name="yourdetails"/>
                <div className={"d-flex justify-content-center section-heading"}>
                    {!isCompleted  && <SVG src={icon} className={""}/>}
                    {isCompleted && <SVG src={tickSvg}/>}<h4 className={"pt-1 pl-1"}>YOUR DETAILS</h4>
                </div>

                <MultipleInputFields labelText={"Full name"} targetField={"firstname"}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"}/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"}
                            helperText={"10 digits."}/>

                {brandConfig &&                 <div className="form-group">
                    <p className={"privacy-policy"}>
                        Stellantis (Australia and New Zealand) Pty Ltd (Stellantis Australia) respects your privacy. We will only use the information
                        you
                        provide for the purposes of processing and fulfilling your request or enquiry. We
                        may
                        disclose your information to an authorised dealer, our related companies and/or
                        third
                        parties associated with us for these purposes. If you have consented on this form,
                        we may
                        also use and disclose your information to send you marketing material about products
                        and
                        services which may be of interest to you. If you have asked to be contacted by a
                        dealer, we
                        may also disclose your information to an dealer for that purpose.
                        Our <a href={brandConfig.privacypolicy} target={"_blank"}>Privacy
                        Policy </a>
                        contains further details regarding how you can access or correct information we hold
                        about
                        you, how you can make a privacy related complaint, how that complaint will be dealt
                        with and
                        the extent to which your information may be disclosed to overseas recipients.
                    </p>
                </div>
                }
                {brand && <CheckBox
                    labelText={`I wish to receive special offers, events and news from ${brand.name} Australia`}
                    name={"marketingOptIn"}/> }

            </div>

        )
    }

    const YourDetailsComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            phone : selector(state, 'phone'),
            'marketingOptIn' : selector(state , 'marketingOptIn'),
            brandConfig : selector(state, 'brandConfig'),
            brand : selector(state,'brand')
        }
    })(Component);

    return <YourDetailsComponent {...props}/>
}

export function ContactUsDetails(props){

    const {formName, icon} = props;

    function Component(p){
        const { firstname, lastname , email , postcode , phone , brand , privacy , owner , brandConfig } = p;
        const isCompleted = [firstname , lastname , email, postcode , phone , owner ].every((i) => i !== undefined && i.trim().length > 0) && privacy;
        const displayStep  = p.displayStep || true;

        return (



            <div id={'contactus'} className={" col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    <h4 className={"pt-1 pl-1"}>CONTACT INFORMATION</h4>
                </div>

                {brand && <DropDownMenu labelText={`Please select your reason for contacting ${brand.name}`} name={'reason'} required={false} items={["General Enquiry",
                    "Service & Maintenance", "Parts & Accessories" , "Recall" , "Complaint"
                ]}/>}


                <MultipleInputFields labelText={"Full name"} targetField={"firstname"}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"} maxLength={20}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"} maxLength={20}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} maxLength="80"/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} helperText={"10 digits."} maxlength="14"/>

                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} placeholder={"E.g. 2000"}/>

                <ContactUsOwnerOptions labelText={`Are you contacting us about a vehicle you own?`} />

                { owner && owner === "yes" && <InputField labelText={"Vehicle Registration (optional)"} name={"vehicleregistration"} placeholder={""} maxLength="30"/>}
                { owner && owner === "yes" && <div>
                        <InputField labelText={"VIN"} name={"vin"} placeholder={""} maxLength="30"/> 
                        <VINModal brand={brand.name}/>
                    </div>
                }


                <TextArea labelText={"Additional Comments"} type={"textarea"} name={"comments"} maxLength={100000} helperText={"Max 100,000 characters."}/>

                {brand && <CheckBox labelText={`I agree to provide my Personal Information to Stellantis (Australia & New Zealand) Pty Ltd in accordance with the terms highlighted below.`} name={"privacy"}/> }

                {brandConfig && <div className="form-group">
                    <p className={"privacy-policy"}>Your enquiry will be forwarded to Stellantis (Australia & New Zealand) Pty Ltd's Customer Service Provider, CDM Direct. Stellantis (Australia & New Zealand) Pty Ltd and CDM Direct respect your privacy and we will only use the information you provide for the purposes of processing and fulfilling your request or enquiry. If you do not provide personal information requested, we may be unable to do this. We may disclose personal information to our related entities or other third parties (which may be located overseas, including in New Zealand) where necessary to deal with your request. Stellantis (Australia & New Zealand) Pty Ltd's <a href={"https://www.jeep.com.au/owners/privacy.html"} target={"_blank"}>Privacy Policy</a> contains further details regarding how you can access or correct information we hold about you, how you can make a privacy-related complaint, how that complaint will be dealt with, and the extent to which your information may be disclosed to overseas recipients.</p>
                </div>}
            </div>

        )
    }

    const ContactUsDetailsComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            owner : selector(state, 'owner'),
            'privacy' : selector(state , 'privacy'),
            brand : selector(state, 'brand'),
            brandConfig : selector(state, 'brandConfig'),

        }
    })(Component);

    return <ContactUsDetailsComponent {...props}/>
}

export function ContactRecallDetails(props){

    const {formName, icon} = props;

    function Component(p){
        const { firstname, lastname , email , postcode , phone , brand , privacy , informed , owner , brandConfig } = p;
        const isCompleted = [firstname , lastname , email, postcode , phone , owner ].every((i) => i !== undefined && i.trim().length > 0) && privacy;
        const displayStep  = p.displayStep || true;

        return (



            <div id={'contactus'} className={" col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    <h4 className={"pt-1 pl-1"}>WE’D LIKE TO HEAR FROM YOU</h4>
                </div>

                {brand && <DropDownMenu labelText={`Please select your reason for contacting ${brand.name}`} name={'reason'} required={false} items={["I have feedback or suggestions for the Jeep team (comment below)",
                    "I would like to be contacted by Jeep", "I have a specific complaint or issue with my vehicle that I would like to discuss" 
                ]}/>}


                <MultipleInputFields labelText={"Full name"} targetField={"firstname"}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"} maxLength={20}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"} maxLength={20}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} maxLength="80"/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} helperText={"10 digits."} maxlength="14"/>

                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} placeholder={"E.g. 2000"}/>

                <ContactUsOwnerOptions labelText={`Are you contacting us about a vehicle you own?`} />

                { owner && owner === "yes" && <InputField labelText={"Vehicle Registration (optional)"} name={"vehicleregistration"} placeholder={""} maxLength="30"/>}
                { owner && owner === "yes" && <InputField labelText={"VIN (optional)"} name={"vin"} placeholder={""} maxLength="30"/> }


                <TextArea labelText={"Your Comments"} type={"textarea"} name={"comments"} maxLength={100000} helperText={"Max 100,000 characters."}/>

                {brand && <CheckBox labelText={`I would like to be kept informed of Jeep’s program of change`} name={"informed"}/> }
                
                {brand && <CheckBox labelText={`I agree to provide my Personal Information to FCA Australia in accordance with the terms highlighted below.`} name={"privacy"}/> }

                {brandConfig && <div className="form-group">
                    <p className={"privacy-policy"}>Your enquiry will be forwarded to FCA Australia's Customer Service Provider, Allianz Worldwide.  FCA and Allianz respect your privacy and we will only use the information you provide for the purposes of processing and fulfilling your request or enquiry.  If you do not provide personal information requested, we may be unable to do this.  We may disclose personal information to our related entities or other third parties (which may be overseas recipients) where necessary to deal with your request.  FCA's Privacy Policy and Allianz's Privacy Policy contain further details regarding how you can access or correct information we hold about you, how you can make a privacy-related complaint, how that complaint will be dealt with, and the extent to which your information may be disclosed to overseas recipients.</p>
                </div>}
            </div>

        )
    }

    const ContactRecallDetailsComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            owner : selector(state, 'owner'),
            'privacy' : selector(state , 'privacy'),
            'informed' : selector(state , 'informed'),
            brand : selector(state, 'brand'),
            brandConfig : selector(state, 'brandConfig'),

        }
    })(Component);

    return <ContactRecallDetailsComponent {...props}/>
}

export function WFFHDetails(props){
    const {formName, icon} = props;


    function Component(p){

        const { firstname, lastname , email , postcode , phone , brand, brandConfig, owner }  = p;
        const isCompleted = [firstname , lastname , email, postcode , phone ].every((i) => i !== undefined && i.trim().length > 0);
        const displayStep  = p.displayStep === undefined ? true : p.displayStep;
        return (



            <div id={'yourdetails'} className={" col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <a name="yourdetails"/>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    {displayStep && !isCompleted  && <SVG src={icon}/>}
                    {displayStep && isCompleted && <SVG src={tickSvg}/>}<h4 className={"pt-1 pl-1"}>YOUR DETAILS</h4>
                </div>

                <MultipleInputFields labelText={"Full name"} targetField={"firstname"} required={true}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Occupation"} name={"occupation"} placeholder={"Occupation"} required={true}/>
                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} required={true}/>
                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} required={true} />
                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} required={true} placeholder={"E.g. 2000"}/>
                {owner && <InputField labelText={"Vehicle Registration"} name={"vehicleregistration"} required={true} placeholder={""} maxLength="30"/> }
                <TextArea id={'answer'} name={'answer'} labelText={'IN 50 WORDS OR LESS, TELL US WHAT YOU COULD ACHIEVE WORKING FAR FROM HOME IN THE SPACECUBE'} required={true}/>
                <VideoInput labelText={'Video (Optional)'} id={'video'}  name={'video'} subLabelText={"Submit a short video (max one minute) telling us more about why you want to #WFFH"} required={false}/>
                <VideoDisplay labelText={''} name={'videoblob'} id={'videoblob'}/>

                {brandConfig && <div className="form-group">
                    <p className={"privacy-policy"}>
                        Stellantis (Australia and New Zealand) Pty Ltd (Stellantis Australia) respects your privacy. We will only use the information
                        you
                        provide for the purposes of processing and fulfilling your request or enquiry. We
                        may
                        disclose your information to an authorised dealer, our related companies and/or
                        third
                        parties associated with us for these purposes. If you have consented on this form,
                        we may
                        also use and disclose your information to send you marketing material about products
                        and
                        services which may be of interest to you. If you have asked to be contacted by a
                        dealer, we
                        may also disclose your information to an dealer for that purpose.
                        Our <a href={brandConfig.privacypolicy} target={"_blank"}>Privacy
                        Policy </a>
                        contains further details regarding how you can access or correct information we hold
                        about
                        you, how you can make a privacy related complaint, how that complaint will be dealt
                        with and
                        the extent to which your information may be disclosed to overseas recipients.
                    </p>
                    <p className={"privacy-policy"}>
                        By entering this promotion, I acknowledge I have read, understood and accept the <a href={owner ? brandConfig.wffhCompTermsOwner : brandConfig.wffhCompTerms} target={"_blank"}>Terms and Conditions</a> of this promotion.
                    </p>
                </div>
                }
                {brand && <CheckBox
                    labelText={`I wish to receive special offers, events and news from ${brand.name} Australia`}
                    name={"marketingOptIn"}/> }

            </div>

        )
    }

    const WFFHComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            'privacy' : selector(state , 'privacy'),
            marketingOptIn : selector(state, 'marketingOptIn'),
            brand : selector(state, 'brand'),
            owner : selector(state, 'owner'),
            vehicleregistration : selector(state, 'vehicleregistration'),
            brandConfig : selector(state, 'brandConfig'),
        }
    })(Component);

    return <WFFHComponent {...props}/>

}

export function YourDetails(props){

    const {formName, icon} = props;


    function Component(p){

        const { firstname, lastname , email , postcode , phone , brand, brandConfig }  = p;
        const isCompleted = [firstname , lastname , email, postcode , phone ].every((i) => i !== undefined && i.trim().length > 0);
        const displayStep  = p.displayStep === undefined ? true : p.displayStep;
        return (



            <div id={'yourdetails'} className={" col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <a name="yourdetails"/>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    {displayStep && !isCompleted  && <SVG src={icon}/>}
                    {displayStep && isCompleted && <SVG src={tickSvg}/>}<h4 className={"pt-1 pl-1"}>REGISTER YOUR INTEREST</h4>
                </div>
                {brand && brand.name === "Leapmotor" && false &&
                    <div className={"col-12 d-flex justify-content-center section-heading text-center"}>
                        All Leapmotor C10 BEV's purchased and delivered by March 31st 2025 will receive 12 months complimentary charging^ via our partnership with Australia's largest EV charging network, Chargefox.
                    </div>
                }

                <MultipleInputFields labelText={"Full name"} targetField={"firstname"} required={true}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} required={true}/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} required={true}
                            helperText={"10 digits."}/>


                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} required={true}
                            placeholder={"E.g. 2000"}/>

                {brandConfig && <div className="form-group">
                    {brand && brand.name === "Leapmotor" ? (
                        <p className={"privacy-policy"}>
                            {/*^12 months complimentary charging offer utilises the Chargefox Platform public chargers only and applies to new Leapmotor C10 BEV vehicles purchased and delivered before 31st March 2025 or while stocks last. Subscription will commence from date of first registration. Excludes vehicles used for commercial purposes, including rideshare, taxi, VHA and couriers. Use of the Chargefox Charging Network and offer is subject to Chargefox terms and conditions available at <a href="https://www.chargefox.com/legal/terms-conditions" target="_blank" rel="noopener noreferrer" className="underline">www.chargefox.com/legal/terms-conditions</a>. Cannot be used in conjunction with any other offer. Leapmotor reserves the right to extend, withdraw or vary the offer.<br/><br/>*/}
                            Stellantis (Australia and New Zealand) Pty Ltd trading as Leapmotor ("Leapmotor") respects your privacy. We will only use the information you provide for the purposes of processing and fulfilling your request or enquiry. We may disclose your information to an authorised dealer, our related companies and/or third parties associated with us for these purposes. If you have consented on this form, we may also use and disclose your information to send you marketing material about products and services which may be of interest to you. Our <a href={"https://www.leapmotor.net/au/privacy-policy"} target={"_blank"}>Privacy Policy</a> contains further details regarding how you can access or correct information we hold about you, how you can make a privacy related complaint, how that complaint will be dealt with and the extent to which your information may be disclosed to overseas recipients.
                        </p>
                    ) : (
                        <p className={"privacy-policy"}>
                            Stellantis (Australia and New Zealand) Pty Ltd (Stellantis Australia) respects your privacy. We will only use the information
                            you
                            provide for the purposes of processing and fulfilling your request or enquiry. We
                            may
                            disclose your information to an authorised dealer, our related companies and/or
                            third
                            parties associated with us for these purposes. If you have consented on this form,
                            we may
                            also use and disclose your information to send you marketing material about products
                            and
                            services which may be of interest to you. If you have asked to be contacted by a
                            dealer, we
                            may also disclose your information to an dealer for that purpose.
                            Our <a href={brandConfig.privacypolicy} target={"_blank"}>Privacy
                            Policy </a>
                            contains further details regarding how you can access or correct information we hold
                            about
                            you, how you can make a privacy related complaint, how that complaint will be dealt
                            with and
                            the extent to which your information may be disclosed to overseas recipients.
                        </p>
                    )}
                </div>
                }
                {brand && <CheckBox
                    labelText={`I wish to receive special offers, events and news from ${brand.name == "Leapmotor" ? "Leapmotor" : (brand.name + " Australia")} `}
                    name={"marketingOptIn"}/> }

            </div>

        )
    }

    const YourDetailsComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            'privacy' : selector(state , 'privacy'),
            marketingOptIn : selector(state, 'marketingOptIn'),
            brand : selector(state, 'brand'),
            brandConfig : selector(state, 'brandConfig')
        }
    })(Component);

    return <YourDetailsComponent {...props}/>
}

export function CompetitionDetails(props){

    const {formName, icon} = props;

    function Component(p){
        const { firstname, lastname , email , postcode , phone , brand , privacy , brandConfig , competitionAnswer } = p;
        const isCompleted = [firstname , lastname , email, postcode , phone , competitionAnswer ].every((i) => i !== undefined && i.trim().length > 0) && privacy;
        const displayStep  = p.displayStep || true;

        return (



            <div id={'contactus'} className={" col-sm-12 col-lg-6 col-md-6 offset-md-3 offset-lg-3 " + (isCompleted ? ` selected ` : `` ) }>
                <div className={"col-12 d-flex justify-content-center section-heading"}>
                    <h4 className={"pt-1 pl-1"}>YOUR DETAILS</h4>
                </div>

                <MultipleInputFields labelText={"Full name"} targetField={"firstname"}>
                    <div className="input-group">
                        <NoLabelField className={"inline"} name={"firstname"} type={"text"} maxLength={20}
                                      placeholder={"First name"}/>
                        <NoLabelField className={"inline"} name={"lastname"} type={"text"} maxLength={20}
                                      placeholder={"Last name"}/>
                    </div>
                </MultipleInputFields>

                <InputField labelText={"Email address"} name={"email"} placeholder={"Email address"} maxLength="80"/>

                <InputField labelText={"Phone"} name={"phone"} placeholder={"Phone"} helperText={"10 digits."} maxlength="14"/>

                <InputField labelText={"Postcode"} name={"postcode"} type={"text"} placeholder={"E.g. 2000"}/>

                <InputField labelText={"What would you rename the Trackhawk?"} type={"text"} name={"competitionQuestion"} maxLength={30} helperText={"Max 30 characters."}/>

                {brandConfig &&                 <div className="form-group">
                    <p className={"privacy-policy"}>
                        By entering this promotion, I acknowledge I have read, understood and accept the <a href={'https://www.jeep.com.au/bathusrt-win-competition-terms.html'} target={"_blank"}>Terms and Conditions</a> of this promotion
                    </p>
                </div>
                }
                {brand && <CompCheckBox
                    labelText={``}
                    name={"privacy"}/> }
            </div>

        )
    }

    const CompetitionComponent = connect((state) => {
        const selector = formValueSelector(formName);
        return {
            firstname : selector(state, 'firstname'),
            lastname : selector(state, 'lastname'),
            email : selector(state, 'email'),
            postcode : selector(state, 'postcode'),
            phone : selector(state, 'phone'),
            marketingOptIn : selector(state, 'marketingOptIn'),
            'privacy' : selector(state , 'privacy'),
            brand : selector(state, 'brand'),
            brandConfig : selector(state, 'brandConfig'),

        }
    })(Component);

    return <CompetitionComponent {...props}/>
}


